module.exports = __webpack_public_path__ + "img/rightInfo2.c59b136d.png";